<template>
  <div class="searchTypes">
    <span>Search by:</span>
    <button class="searchType" @click="setSearchType('displayName')">
      Display
    </button>
    <button class="searchType" @click="setSearchType('firstName')">
      First
    </button>
    <button class="searchType" @click="setSearchType('lastName')">Last</button>
    <button class="searchType" @click="setSearchType('_id')">userID</button>
    <button class="searchType" @click="setSearchType('email')">Email</button>
  </div>
</template>

<script>
export default {
  name: "UserSearchTypes",
  methods: {
    setSearchType(type) {
      this.$emit("setSearchType", type);
    },
  },
};
</script>